export const PAGINATION_PER_PAGE_OPTIONS = [5, 10, 30, 50]
export const PAGINATION_DEFAULT_PER_PAGE = 10
